import { render, staticRenderFns } from "./NormalSearchNav242.vue?vue&type=template&id=70908388&scoped=true"
import script from "./NormalSearchNav242.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav242.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70908388",
  null
  
)

export default component.exports